import script from "./SovaClubFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./SovaClubFooter.vue?vue&type=script&setup=true&lang=js"

import "./SovaClubFooter.vue?vue&type=style&index=0&id=3e65bf74&lang=scss&scoped=true"

import exportComponent from "/Users/sup/Documents/work/sova/sova/local/templates/globalSova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e65bf74"]])

export default __exports__